// Changelog configuration
// Update this file whenever you release a new update
//
// HOW TO UPDATE:
// 1. Update CHANGELOG_HEADER.version (this is tracked in localStorage)
// 2. Update CHANGELOG_HEADER.date to current date
// 3. Add your changes to CHANGELOG_ITEMS array
// 4. Each item needs: type ('NOVO' | 'POBOLJŠANJE' | 'POPRAVKA'), title, description

// Static intro text - always displayed (don't change this)
export const CHANGELOG_INTRO = 'Novo ažuriranje Rezervatora donosi potpuno novi prikaz statistike, naprednije upravljanje otkazivanjima, nove mogućnosti za marketing i automatizaciju komunikacije.';

// Header configuration
// Update version and date for each release
export const CHANGELOG_HEADER = {
  title: 'Stiglo je novo osvježenje!', // Modal title
  version: '3.0.0', // ⚠️ IMPORTANT: Change this for each update (tracked in localStorage)
  date: 'Oktobar 2026.', // Display date
};

// Changelog items - add your changes here
// type: 'NOVO' | 'POBOLJŠANJE' | 'POPRAVKA'
// title: Short title of the change
// description: Detailed description of what was changed
export const CHANGELOG_ITEMS = [
  {
    type: 'NOVO' as const,
    title: 'Novi prikaz statistike',
    description: 'Statistika u Rezervatoru dobila je potpuno novi izgled. Podaci su sada prikazani jasnije i preglednije, uz više mogućnosti za filtriranje, sortiranje i kontrolu prikaza. Sve prikazane podatke moguće je i izvesti u PDF, u formatu prilagođenom za pregled i printanje.',
  },
  {
    type: 'NOVO' as const,
    title: 'Unaprijeđeno otkazivanje rezervacija',
    description: 'Otkazivanje rezervacija sada je detaljnije i preglednije, bez obzira da li se otkazivanje vrši kroz Admin/Employee panel ili od strane klijenta/pacijenta. Omogućeno je pojedinačno otkazivanje usluga iz vezanih rezervacija, evidentiranje razloga otkazivanja i jasan prikaz razloga otkazivanja direktno u kalendaru. Razlozi otkazivanja sada su dostupni i u novoj statistici, što omogućava bolji pregled i analizu otkazanih termina.',
  },
  {
    type: 'NOVO' as const,
    title: 'Workflow – automatske poruke',
    description: 'Nova Workflow funkcionalnost omogućava samostalno uređivanje automatskih email obavještenja koja se šalju vašim klijentima/pacijentima. Za uključivanje ove funkcionalnosti javite se našoj Podršci.',
  },
  {
    type: 'NOVO' as const,
    title: 'Novi Marketing prostor',
    description: 'Marketing funkcionalnosti sada imaju svoj zaseban tab i pregledniji prostor za rad. Korisnici sa odgovarajućim ovlaštenjima mogu kreirati vlastite liste klijenata/pacijenata, importovati .csv liste i jednostavnije organizovati podatke za marketing aktivnosti. Za uključivanje ove funkcionalnosti javite se našoj Podršci.',
  },
  {
    type: 'NOVO' as const,
    title: 'Nova Rezervator web stranica',
    description: 'Rezervator je dobio i potpuno redizajniranu landing stranicu, sa modernijim izgledom i jasnijim prikazom mogućnosti sistema.',
  },
  {
    type: 'POBOLJŠANJE' as const,
    title: 'Pretraga klijenata/pacijenata po broju telefona',
    description: 'U tabu Klijenti/Pacijenti listu je sada moguće pretraživati i prema broju telefona.',
  },
  {
    type: 'POBOLJŠANJE' as const,
    title: 'Pregled marketing poruka',
    description: 'Korisnicima koji imaju uključene marketing poruke sada je vidljiv i broj dostupnih/potrošenih marketing poruka.',
  },
  {
    type: 'POPRAVKA' as const,
    title: 'Ispravke i optimizacije',
    description: 'Uz nove funkcionalnosti, izvršene su dodatne ispravke bugova i optimizacije sistema radi stabilnijeg i ugodnijeg korištenja Rezervatora.',
  },
];

// Storage key for tracking seen changelog versions
export const CHANGELOG_STORAGE_KEY = 'changelog_seen_version';

// Export version for easy access
export const CHANGELOG_VERSION = CHANGELOG_HEADER.version;
